
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wir gähnen, wenn wir müde sind, uns langweilen– oder angegähnt werden. Diese Auslöser sind hinreichend belegt. Doch welchen Zweck das weite Aufreissen des Mundes hat, ist noch nicht eindeutig geklärt. Sicher scheint nur eins: `}<M mdxType="M">{`Eine Reaktion auf Sauerstoffmangel ist es – anders als häufig behauptet wird – nicht.`}</M>{` Tatsache ist nur, dass wir Menschen und auch die meisten Wirbeltierarten gähnen.`}<br /><br />{`
In den 80er-Jahren war der amerikanische Psychologe Robert Provine der Erste, der zeigen konnte, dass Versuchspersonen eher von Gähnvideos zum Gähnen verleitet wurden als von Videos mit lachenden Menschen zum Lachen. Das Verhalten, so die Forscher, muss eine evolutionäre Wurzel haben – etwa als eine Frühform der Empathie. In der Folge wurden in weiteren Arbeiten Hinweise darauf gefunden, dass Gähnen auch bei Schimpansen, domestizierten Hunden, Ratten und möglicherweise sogar bei Wölfen und Affen ansteckend sein könnte. `}<M mdxType="M">{`Seither gilt ansteckendes Gähnen sogar als ein Zeichen für Tierarten mit höherem Bewusstsein.`}</M>{` Wer gähnt, so das neue Paradigma, verfügt über eine «Theory of Mind», die Fähigkeit also, sich in jemand anderen hineinzuversetzen.`}<br /><br />{`
Doch viele dieser Resultate sind anekdotisch oder liessen sich bisher in Experimenten nicht wiederholen. So ist immer noch unklar, was das kollektive Gähnen überhaupt bringt. Trägt es zum Zusammenhalt einer Gruppe bei, und wenn ja, wie? Hat es eine kommunikative Funktion, und wenn ja, was genau signalisiert es? Was genau löst das Gähnen aus, und welchen Effekt hat es? Da sind noch viele Elemente nicht schlüssig bewiesen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;